import React from "react"
import styled from "styled-components"
import SkeletonLoader from "./SkeletonLoader"
import { ACTIVE_HEADER_VARIANT, HEADER_VARIANTS } from "../config/headerTheme"

const CardInfoLike = ({ loading }) => {
  return (
    <Container>
      <SkeletonLoader
        active={loading}
        width="40%"
        height="18px"
        borderRadius="15px"
        margin="0 auto 14px"
        display="flex"
      >
        <Title>Apóyanos</Title>
      </SkeletonLoader>

      <SkeletonLoader
        active={loading}
        width="60%"
        height="15px"
        borderRadius="15px"
        margin="10px auto"
        display="flex"
      >
        <TextDesc>Cada voto suma Puntos</TextDesc>
      </SkeletonLoader>

      <SkeletonLoader
        active={loading}
        width="50%"
        height="15px"
        borderRadius="15px"
        margin="10px auto"
        display="flex"
      >
        <TextPress>Toca la chapa para calificar</TextPress>
      </SkeletonLoader>
    </Container>
  )
}

export default CardInfoLike

/* ========= Styled Components ========= */

const Container = styled.div`
  text-align: center;
  margin-top: 20px;
`

const Title = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
`

const TextDesc = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: #111827;
  text-align: center;
  margin: 0;
`

const TextPress = styled.p`
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  margin: 0;
  color: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};
`
